import React, { useState, useEffect } from 'react';
import './Partners.css';
import iconBack from '../../assets/icon-back-2.svg';
import { supabase } from '../../lib/supabase';

interface PartnersProps {
  onBack: () => void;
}

interface Partner {
  id: string;
  name: string;
  address: string;
  phone: string;
  business_hours: string;
  image_url: string;
  display_order: number;
  is_active: boolean;
}

const Partners: React.FC<PartnersProps> = ({ onBack }) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const { data, error } = await supabase
          .from('partners')
          .select('*')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        if (error) {
          console.error('Error fetching partners:', error);
          return;
        }

        setPartners(data || []);
      } catch (error) {
        console.error('Error fetching partners:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  return (
    <div className="partners-container">
      <div className="partners-header">
        <div className="partners-header-wrapper">
          <img src={iconBack} alt="뒤로가기" className="header-icon" onClick={onBack} />
          <h1 className="partners-title">협력사</h1>
          <div className="header-icon"></div>
        </div>
      </div>

      <div className="partners-content">
        <h2 className="partners-page-title">협력사</h2>
        {loading ? (
          <div className="loading">로딩 중...</div>
        ) : partners.length === 0 ? (
          <div className="empty">등록된 협력사가 없습니다.</div>
        ) : (
          <div className="partners-list">
            {partners.map((partner) => (
              <div key={partner.id} className="partner-card">
                <div className="partner-image">
                  <img src={partner.image_url} alt={partner.name} />
                </div>
                <div className="partner-info">
                  <h3 className="partner-name">{partner.name}</h3>
                  <div className="partner-details">
                    <p className="partner-address">{partner.address}</p>
                    <p className="partner-phone">{partner.phone}</p>
                    <p className="partner-hours">{partner.business_hours}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Partners;
